import { USER_ROLE } from '@/entities/user/constants';
import type { Member } from '@/entities/member/types';

const BASE_MEMBERS: Member[] = [
  {
    id: 'mock-user-1',
    email: 'alex.chen@syncly.ai',
    first_name: 'Alex',
    last_name: 'Chen',
    privilege: USER_ROLE.OWNER,
  },
  {
    id: 'mock-user-2',
    email: 'mina.park@syncly.ai',
    first_name: 'Mina',
    last_name: 'Park',
    privilege: USER_ROLE.MANAGER,
  },
  {
    id: 'mock-user-3',
    email: 'jordan.lee@syncly.ai',
    first_name: 'Jordan',
    last_name: 'Lee',
    privilege: USER_ROLE.VIEWER,
  },
];

let mockMembers: Member[] = structuredClone(BASE_MEMBERS);

export function initMockMemberDB() {
  mockMembers = structuredClone(BASE_MEMBERS);
}

export function getMockMembers() {
  return structuredClone(mockMembers);
}

export function updateMockMemberRole(memberId: string, privilege: USER_ROLE) {
  mockMembers = mockMembers.map((member) =>
    member.id === memberId ? { ...member, privilege } : member,
  );

  return mockMembers.find((member) => member.id === memberId) ?? null;
}
